<p-confirmPopup />

<!-- =========================================================
     DIÁLOGOS: Payload y Respuesta
     ========================================================= -->
<p-dialog header="Payload Enviado" [(visible)]="showPayloadDialog"
  [modal]="true" appendTo="body" [style]="{ width: '700px' }" [dismissableMask]="true">
  <pre class="text-sm overflow-auto m-0" style="max-height: 420px; background: #1e1e2e; color: #cdd6f4; padding: 1rem; border-radius: 6px; white-space: pre-wrap;">{{ selectedLog ? prettyJson(selectedLog.payloadSent) : '' }}</pre>
</p-dialog>

<p-dialog header="Respuesta Recibida" [(visible)]="showResponseDialog"
  [modal]="true" appendTo="body" [style]="{ width: '700px' }" [dismissableMask]="true">
  <pre class="text-sm overflow-auto m-0" style="max-height: 420px; background: #1e1e2e; color: #cdd6f4; padding: 1rem; border-radius: 6px; white-space: pre-wrap;">{{ selectedLog ? prettyJson(selectedLog.responseReceived) : '' }}</pre>
</p-dialog>

<!-- =========================================================
     CARD PRINCIPAL
     ========================================================= -->
<p-card header="Integraciones EPP">
  <p-tabView>

    <!-- ════════ Tab 1: Configuraciones ════════ -->
    <p-tabPanel header="Configuraciones">

      <p-toolbar *ngIf="!showForm" styleClass="mb-4 gap-2">
        <ng-template pTemplate="right">
          <button pButton pRipple label="Nueva integración" icon="pi pi-plus"
            class="p-button-success mr-2" (click)="openNew()"></button>
        </ng-template>
      </p-toolbar>

      <!-- Loading -->
      <div *ngIf="!showForm && listLoading" class="flex justify-content-center p-5">
        <p-progressSpinner strokeWidth="4" />
      </div>

      <!-- Estado vacío -->
      <div *ngIf="!showForm && !listLoading && integrations.length === 0"
        class="flex flex-column align-items-center justify-content-center p-6 text-center">
        <i class="pi pi-link text-6xl text-300 mb-4"></i>
        <h3 class="text-600 mt-0 mb-2">Sin integraciones configuradas</h3>
        <p class="text-400 mb-4 max-w-20rem">
          Configura una integración REST para sincronizar entregas EPP con tu sistema externo.
        </p>
        <p-button label="Crear primera integración" icon="pi pi-plus" (click)="openNew()" />
      </div>

      <!-- Grid de tarjetas -->
      <div *ngIf="!showForm && !listLoading && integrations.length > 0" class="grid">
        <div *ngFor="let config of integrations" class="col-12 md:col-6 lg:col-4">
          <p-card styleClass="h-full shadow-1 hover:shadow-3 transition-all transition-duration-200">

            <ng-template pTemplate="header">
              <div class="flex align-items-center justify-content-between px-3 pt-3 gap-2">
                <p-tag
                  [severity]="config.isActive ? 'success' : 'secondary'"
                  [value]="config.isActive ? 'Activa' : 'Inactiva'" />
                <p-tag severity="info" [value]="getAuthTypeLabel(config.authType)" />
              </div>
            </ng-template>

            <ng-template pTemplate="content">
              <h3 class="text-900 font-bold mb-1 mt-0 line-clamp-1">{{ config.name }}</h3>
              <p class="text-500 text-sm mb-2 line-clamp-2 min-h-2rem" *ngIf="config.description">
                {{ config.description }}
              </p>
              <div class="text-xs font-mono text-400 white-space-nowrap overflow-hidden text-overflow-ellipsis"
                [pTooltip]="config.endpointUrl" tooltipPosition="bottom">
                <span class="text-primary font-bold">{{ config.httpMethod }}</span>
                {{ config.endpointUrl }}
              </div>
              <div class="text-xs text-400 mt-2 flex gap-3 flex-wrap">
                <span><i class="pi pi-clock mr-1"></i>Timeout: {{ config.timeoutSeconds }}s</span>
                <span><i class="pi pi-replay mr-1"></i>Reintentos: {{ config.maxRetries }}</span>
                <span *ngIf="config.isAutoSync" class="text-green-500">
                  <i class="pi pi-bolt mr-1"></i>Auto-sync
                </span>
              </div>
            </ng-template>

            <ng-template pTemplate="footer">
              <div class="flex gap-2">
                <p-button icon="pi pi-pencil" label="Editar"
                  styleClass="p-button-outlined p-button-sm flex-1"
                  (click)="openEdit(config)" />
                <p-button icon="pi pi-trash"
                  styleClass="p-button-outlined p-button-danger p-button-sm"
                  (click)="confirmDelete($event, config.id)"
                  pTooltip="Eliminar" />
              </div>
            </ng-template>

          </p-card>
        </div>
      </div>

      <!-- =========================================================
           FORMULARIO: crear / editar integración (inline, mismo lugar)
           ========================================================= -->
      <p-panel *ngIf="showForm"
        [header]="mode === 'add' ? 'Nueva Integración EPP' : 'Editar Integración EPP'">

        <form [formGroup]="integrationForm">
          <p-tabView>

            <!-- ── Tab: General ── -->
            <p-tabPanel header="General">
              <div class="p-fluid">

                <div class="field">
                  <label for="name">Nombre <span class="text-red-500">*</span></label>
                  <input id="name" pInputText formControlName="name" placeholder="Ej. Integración Corpacero" />
                  <small class="text-red-500"
                    *ngIf="integrationForm.get('name')?.invalid && integrationForm.get('name')?.dirty">
                    El nombre es obligatorio
                  </small>
                </div>

                <div class="field">
                  <label for="description">Descripción</label>
                  <textarea id="description" pInputTextarea formControlName="description" rows="3"
                    placeholder="Descripción opcional"></textarea>
                </div>

                <div class="field">
                  <label>Integración activa</label>
                  <div class="flex align-items-center gap-2 mt-1">
                    <p-inputSwitch formControlName="isActive" />
                    <span>{{ integrationForm.get('isActive')?.value ? 'Activa' : 'Inactiva' }}</span>
                  </div>
                </div>

                <div class="field">
                  <label>Sincronización automática al entregar</label>
                  <div class="flex align-items-center gap-2 mt-1">
                    <p-inputSwitch formControlName="isAutoSync" />
                    <span>{{ integrationForm.get('isAutoSync')?.value ? 'Automática' : 'Manual' }}</span>
                  </div>
                  <small class="text-500" *ngIf="!integrationForm.get('isAutoSync')?.value">
                    La integración existirá pero no se disparará automáticamente. Se puede reenviar desde el historial.
                  </small>
                </div>

              </div>
            </p-tabPanel>

            <!-- ── Tab: Endpoint ── -->
            <p-tabPanel header="Endpoint">
              <div class="p-fluid">

                <div class="field">
                  <label for="endpointUrl">URL del endpoint <span class="text-red-500">*</span></label>
                  <input id="endpointUrl" pInputText formControlName="endpointUrl"
                    placeholder="https://api.cliente.com/epp/entregas" />
                  <small class="text-red-500"
                    *ngIf="integrationForm.get('endpointUrl')?.invalid && integrationForm.get('endpointUrl')?.dirty">
                    Ingrese una URL válida (https://...)
                  </small>
                </div>

                <div class="field">
                  <label>Método HTTP</label>
                  <p-dropdown formControlName="httpMethod" [options]="httpMethods"
                    optionLabel="label" optionValue="value" appendTo="body" styleClass="w-full" />
                </div>

                <div class="formgrid grid">
                  <div class="field col-6">
                    <label>Timeout (segundos)</label>
                    <p-inputNumber formControlName="timeoutSeconds" [min]="1" [max]="300" styleClass="w-full" />
                  </div>
                  <div class="field col-6">
                    <label>Máximo de reintentos</label>
                    <p-inputNumber formControlName="maxRetries" [min]="0" [max]="10" styleClass="w-full" />
                  </div>
                </div>

              </div>
            </p-tabPanel>

            <!-- ── Tab: Autenticación ── -->
            <p-tabPanel header="Autenticación">
              <div class="p-fluid">

                <div class="field">
                  <label>Tipo de autenticación</label>
                  <p-dropdown formControlName="authType" [options]="authTypes"
                    optionLabel="label" optionValue="value" appendTo="body" styleClass="w-full" />
                </div>

                <!-- Aviso credenciales guardadas al editar -->
                <p-message
                  *ngIf="mode === 'edit' && hasAuthConfigured && authType !== 'NONE'"
                  severity="info"
                  text="Credenciales configuradas. Ingresa nuevas para reemplazarlas."
                  styleClass="mb-3 w-full" />

                <!-- BASIC -->
                <ng-container *ngIf="authType === 'BASIC'">
                  <div class="field">
                    <label>Usuario</label>
                    <input pInputText formControlName="username" placeholder="usuario" />
                  </div>
                  <div class="field">
                    <label>Contraseña</label>
                    <input pInputText type="password" formControlName="password" placeholder="••••••••" />
                  </div>
                </ng-container>

                <!-- BEARER -->
                <ng-container *ngIf="authType === 'BEARER'">
                  <div class="field">
                    <label>Token</label>
                    <textarea pInputTextarea formControlName="token" rows="4"
                      placeholder="eyJhbGci..."></textarea>
                  </div>
                </ng-container>

                <!-- API_KEY -->
                <ng-container *ngIf="authType === 'API_KEY'">
                  <div class="field">
                    <label>Nombre del header</label>
                    <input pInputText formControlName="headerName" placeholder="X-Api-Key" />
                  </div>
                  <div class="field">
                    <label>Valor del header</label>
                    <input pInputText type="password" formControlName="headerValue" placeholder="••••••••" />
                  </div>
                </ng-container>

                <!-- NONE -->
                <div *ngIf="authType === 'NONE'" class="text-500 text-sm mt-2 p-3 border-round surface-100">
                  <i class="pi pi-info-circle mr-2"></i>
                  Sin autenticación configurada. Las peticiones se enviarán sin cabeceras de auth.
                </div>

              </div>
            </p-tabPanel>

            <!-- ── Tab: Payload Template ── -->
            <p-tabPanel header="Payload Template">
              <div class="grid">

                <!-- Editor JSON -->
                <div class="col-12 md:col-7 pr-3">
                  <label class="font-medium">JSON Template</label>
                  <small class="block text-500 mb-2">
                    Usa la notación <code class="text-primary">{{ '{{campo}}' }}</code> para valores dinámicos.
                    Para arrays de ítems envuelve el objeto con <code class="text-primary">[[ ... ]]</code>.
                  </small>
                  <textarea
                    pInputTextarea
                    formControlName="payloadTemplate"
                    [rows]="22"
                    class="w-full"
                    style="font-family: monospace; font-size: 0.8rem; resize: vertical;"
                    [attr.placeholder]="templatePlaceholder">
                  </textarea>
                </div>

                <!-- Panel de placeholders -->
                <div class="col-12 md:col-5 pl-2">
                  <label class="font-medium">Placeholders disponibles</label>
                  <small class="block text-500 mb-2">Haz clic para copiar</small>

                  <div *ngIf="placeholdersLoading" class="flex justify-content-center p-4">
                    <p-progressSpinner strokeWidth="4" [style]="{ width: '28px', height: '28px' }" />
                  </div>

                  <div *ngIf="!placeholdersLoading" class="overflow-auto border-round border-1 surface-border"
                    style="max-height: 430px;">
                    <div
                      *ngFor="let ph of availablePlaceholders"
                      class="flex align-items-center justify-content-between px-3 py-2 border-bottom-1 surface-border hover:surface-100 cursor-pointer"
                      (click)="copyPlaceholder(ph.key)">
                      <span class="text-sm text-800">{{ ph.label }}</span>
                      <code class="text-primary text-xs font-bold white-space-nowrap ml-2">{{ ph.key }}</code>
                    </div>
                    <div *ngIf="availablePlaceholders.length === 0"
                      class="p-3 text-center text-400 text-sm">
                      No hay placeholders disponibles
                    </div>
                  </div>
                </div>

              </div>
            </p-tabPanel>

          </p-tabView>
        </form>

        <div class="flex justify-content-between mt-1">
          <p-button label="Cancelar" styleClass="p-button-rounded p-button-danger"
            (click)="closeForm()" />
          <p-button icon="pi pi-save" label="Guardar" styleClass="p-button-rounded"
            [disabled]="integrationForm.invalid" (click)="save()" />
        </div>
      </p-panel>

    </p-tabPanel>

    <!-- ════════ Tab 2: Historial ════════ -->
    <p-tabPanel header="Historial de Sincronizaciones">

      <!-- Filtros -->
      <form [formGroup]="filterForm">
        <div class="grid mb-3 align-items-end">
          <div class="col-12 md:col-3">
            <label class="block text-sm mb-1">Estado</label>
            <p-dropdown formControlName="syncStatus" [options]="syncStatusOptions"
              optionLabel="label" optionValue="value" placeholder="Todos" [showClear]="true"
              styleClass="w-full" />
          </div>
          <div class="col-12 md:col-2">
            <label class="block text-sm mb-1">Desde</label>
            <p-calendar formControlName="dateFrom" placeholder="dd/mm/aaaa"
              dateFormat="dd/mm/yy" styleClass="w-full" />
          </div>
          <div class="col-12 md:col-2">
            <label class="block text-sm mb-1">Hasta</label>
            <p-calendar formControlName="dateTo" placeholder="dd/mm/aaaa"
              dateFormat="dd/mm/yy" styleClass="w-full" />
          </div>
          <div class="col-12 md:col-2">
            <label class="block text-sm mb-1">Integración</label>
            <p-dropdown formControlName="configId" [options]="configOptions"
              optionLabel="label" optionValue="value" placeholder="Todas" [showClear]="true"
              styleClass="w-full" />
          </div>
          <div class="col-12 md:col-2">
            <label class="block text-sm mb-1">Cód. solicitud</label>
            <p-inputNumber formControlName="eppRequestId" placeholder="0"
              [useGrouping]="false" styleClass="w-full" />
          </div>
          <div class="col-12 md:col-1 flex gap-2">
            <button pButton pRipple icon="pi pi-search" class="p-button-sm"
              pTooltip="Buscar" (click)="loadLogs(1)"></button>
            <button pButton pRipple icon="pi pi-times" class="p-button-sm p-button-outlined"
              pTooltip="Limpiar filtros" (click)="clearLogFilters()"></button>
          </div>
        </div>
      </form>

      <!-- Tabla historial -->
      <p-table
        appResponsiveTable
        responsiveLayout="stack"
        [value]="logs"
        [loading]="logsLoading"
        [lazy]="true"
        (onLazyLoad)="onLogPageChange($event)"
        [paginator]="true"
        [rows]="logPageSize"
        [(first)]="logFirst"
        [totalRecords]="totalLogs"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
        [rowsPerPageOptions]="[20, 50, 100]"
        styleClass="p-datatable-sm p-datatable-striped"
        emptyMessage="No hay registros para los filtros seleccionados.">

        <ng-template pTemplate="header">
          <tr>
            <th>Fecha</th>
            <th>Integración</th>
            <th>Solicitud</th>
            <th>Estado</th>
            <th>HTTP</th>
            <th>Detalle error</th>
            <th style="width: 120px">Acciones</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-log>
          <tr>
            <td>{{ log.syncedAt | date: 'dd/MM/yyyy HH:mm' }}</td>
            <td>{{ log.configName }}</td>
            <td>#{{ log.eppRequestId }}</td>
            <td>
              <p-tag
                [severity]="getSyncStatusSeverity(log.syncStatus)"
                [value]="getSyncStatusLabel(log.syncStatus)" />
            </td>
            <td>
              <span [class]="log.httpStatusCode >= 400 ? 'text-red-500 font-bold' : 'text-green-500'">
                {{ log.httpStatusCode }}
              </span>
            </td>
            <td class="text-xs text-red-400 max-w-15rem text-overflow-ellipsis white-space-nowrap overflow-hidden"
              [pTooltip]="log.errorDetail || ''" tooltipPosition="left">
              {{ log.errorDetail || '—' }}
            </td>
            <td>
              <div class="flex gap-1">
                <button pButton pRipple icon="pi pi-arrow-up-right"
                  pTooltip="Payload enviado" tooltipPosition="left"
                  class="p-button-rounded p-button-text p-button-sm"
                  (click)="viewPayload(log)"></button>
                <button pButton pRipple icon="pi pi-arrow-down-left"
                  pTooltip="Respuesta recibida" tooltipPosition="left"
                  class="p-button-rounded p-button-text p-button-info p-button-sm"
                  (click)="viewResponse(log)"></button>
                <button *ngIf="log.syncStatus === 'ERROR'"
                  pButton pRipple icon="pi pi-replay"
                  pTooltip="Reintentar" tooltipPosition="left"
                  class="p-button-rounded p-button-text p-button-warning p-button-sm"
                  (click)="retrySync($event, log.id)"></button>
              </div>
            </td>
          </tr>
        </ng-template>

      </p-table>

    </p-tabPanel>

  </p-tabView>
</p-card>
